import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import logo from '@assets/images/nav-logo.png';
import { navMenuConfig } from '@constants/menuConfig';
import useValidatePermission from '@hooks/useValidatePermission';
import { Layout, Menu } from 'antd';

import styles from './NavSider.module.scss';
const { Sider } = Layout;

const NavSider = ({ collapsed, onCollapse, width }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const validatePermission = useValidatePermission();

    const activeNav = useMemo(() => {
        const activeNav = findActiveNav(navMenuConfig);

        if (activeNav) {
            return activeNav;
        }

        return {
            selectedKeys: [],
            openKeys: [],
        };
    }, [ location.pathname ]);

    function makeNavs(navs) {
        return navs.map((nav) => {
            const newNav = { ...nav };
            if (newNav.permissions) {
                if (!validatePermission(newNav.permissions)) {
                    return null;
                }
            }

            if (newNav.children) {
                newNav.children = makeNavs(nav.children);
                if (newNav.children.every((item) => item === null)) {
                    return null;
                }
            }

            return newNav;
        });
    }

    function handleMenuItemClick(item) {
        let selectedNav;
        navMenuConfig.forEach((navItem) => {
            if (navItem.key === item.key) selectedNav = navItem;
            else if (navItem.children) {
                navItem.children.forEach((navChild) => {
                    if (navChild.key === item.key) selectedNav = navChild;
                });
            }
        });

        navigate(selectedNav?.path);
    }

    function findActiveNav(navs) {
        for (const nav of navs) {
            if (nav.children) {
                const activeItem = findActiveNav(nav.children);
                if (activeItem) {
                    return {
                        selectedKeys: activeItem.selectedKeys,
                        openKeys: [ nav.key, ...activeItem.openKeys ],
                    };
                }
            } else if (matchPath(nav.path + '/*', location.pathname)) {
                return {
                    selectedKeys: [ nav.key ],
                    openKeys: [],
                };
            }
        }

        // return defaultOpenNav;
    }

    return (
        <Sider
            className={styles.appSider}
            collapsible
            collapsed={collapsed}
            width={width}
            onCollapse={onCollapse}
            trigger={null}
        >
            <div data-collapsed={collapsed} className={styles.logo}>
                <img className={styles.logoImg} src={logo} alt="Digibes" data-collapsed={collapsed} />
                <div className={styles.brandCopy} data-collapsed={collapsed}>
                    <strong>Digibes CMS</strong>
                    <span>Product Operations</span>
                </div>
            </div>
            <Menu
                style={{ marginTop: '12px' }}
                key={location.pathname == '/' ? 'initial' : 'navSider'}
                theme="dark"
                mode="inline"
                className={styles.menu}
                defaultSelectedKeys={activeNav.selectedKeys}
                defaultOpenKeys={activeNav.openKeys}
                selectedKeys={activeNav.selectedKeys}
                items={makeNavs(navMenuConfig)}
                onSelect={(item) => handleMenuItemClick(item)}
            />
        </Sider>
    );
};

export default NavSider;
